import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';
import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export const ApplicationListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TApplicationListSortCol = TTableSortCols<typeof ApplicationListSortCol>;

export type TApplicationListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TApplicationListSortCol;
};

export type TApplicationListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptApplicationListQueryToRequest(data?: TApplicationListQuery): TApplicationListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TApplication = {
  id: number;
  name: string;
  description?: string;
  apiKey?: string;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TApplicationResponse = {
  id: number;
  name: string;
  description?: string;
  api_key?: string;
  created_at: string;
  updated_at: string;

	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TApplicationListResponse = TListResponse<TApplicationResponse>;

export type TApplicationList = TListResponse<TApplication>;

export type TApplicationPayloadRequest = {
	name: string;
	description?: string;
	apiKey: string;
};

export type TApplicationRequest = {
	name: string;
	description?: string;
	api_key: string;
};

export type TApplicationPayloadUpdate = {
	id: number;
	data: TApplicationPayloadRequest;
};

export function adaptApplicationFromListResponse(data: TApplicationListResponse): TApplicationList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptApplicationFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptApplicationFromResponse(data: TApplicationResponse): TApplication {
	const {
		id,
		name,
		description,
		api_key: apiKey,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		name,
		description,
		apiKey,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptApplicationToRequest(data: TApplicationPayloadRequest): TApplicationRequest {
	const {
		name,
		description = undefined,
		apiKey,
	} = data;

	return {
		name,
		description,
		api_key: apiKey,
	};
}
